namespace GeniuzPOS.QRreport {
    export enum WhsFg {
        allwhs = 0,
        bywhs = 1,
        byshop = 2
    }
    Serenity.Decorators.registerEnumType(WhsFg, 'GeniuzPOS.QRreport.WhsFg');
}
